import AnimalIcon from '../AnimalIcon';

export default class OverlayPlayerTwoTurn extends Phaser.Group {
  constructor(game, playerIcon) {
    super(game);

    //
    this.onEnd = new Phaser.Signal();

    // background
    const bg = this.game.make.image(0, 0, 'bg_location_' + this.game.controller.location);
    this.addChild(bg);

    // icon
    const playerNr = this.game.controller.twoPlayersModel.hidingPlayerId === 0 ? 1 : 2;
    this.icon = new AnimalIcon(this.game, 0, 360, playerNr, playerIcon);
    this.icon.x = this.game.defaultWidth / 2;
    this.addChild(this.icon);

    if (playerNr === 1) {
      // for player 1
      this.game.twoPlayersOnboarding.playVOs(['ob_05_elinor_023_alt']);
    } else {
      // for player 2
      this.game.twoPlayersOnboarding.playVOs(['ob_05_elinor_023']);
    }
    this.game.twoPlayersOnboarding.onEnd.addOnce(this.handleOnboardingEnd, this);
  }

  handleOnboardingEnd() {
    this.game.time.events.add(500, this.close, this);
  }

  close() {
    this.onEnd.dispatch();
  }
}
